import React, { useContext } from "react";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import { ContextContent } from "../contentContext";
import "./styles.css";

// Шапка контента: show → карандаш (в edit, по праву edit); edit → крестик (назад в show
// с откатом правок). Для index/create — ничего.
export default function ContentHeader() {
    const contextContent = useContext(ContextContent);

    if (contextContent.isShow && contextContent.isWithEdit && contextContent.checkPermission('edit')) {
        return <div className="content__header">
            <IconButton
                className="content__header-button"
                title="Редактировать"
                onClick={() => contextContent.setType('edit')}
            >
                <EditIcon fontSize="small"/>
            </IconButton>
        </div>;
    }

    if (contextContent.isEdit) {
        return <div className="content__header">
            <IconButton
                className="content__header-button"
                title="Отменить редактирование"
                onClick={() => {
                    contextContent.reSetData();
                    contextContent.setType('show');
                }}
            >
                <CloseIcon fontSize="small"/>
            </IconButton>
        </div>;
    }

    return null;
}
